import { render } from "./TabPlants.vue?vue&type=template&id=4e020725&scoped=true"
import script from "./TabPlants.vue?vue&type=script&lang=js"
export * from "./TabPlants.vue?vue&type=script&lang=js"

import "./TabPlants.vue?vue&type=style&index=0&id=4e020725&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e020725"]])

export default __exports__